import React from 'react'
import {useState, useEffect} from "react";

import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import '../../scss/tabs.scss'

import {useLocation} from 'react-router-dom';
import instance from "../../api/axios";
import {Cookies} from "react-cookie";


const Ameriasuccess = () => {

    const navigate = useNavigate()

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [loading, setLoading] = useState(true);

    const responce = queryParams.get('resposneCode');
    const orderID = queryParams.get('orderID');
    const paymentID = queryParams.get('paymentID');
    let url = process.env.REACT_APP_BASE_URL;

    const [order, setOrder] = useState('')
    const [email, setEmail] = useState('')
    const {t, i18n} = useTranslation()

    const cookies = new Cookies();

    const getOrderInfo = async () => {
        if (responce == '00') {
            await instance.get(`${url}/abio/public/cart/resetOrder`, {
                headers: {
                    'X_ORDER_XSRF_TOKEN': cookies.get('ORDER_XSRF_TOKEN'),
                }, params: {
                    orderId: orderID, paymentID: paymentID
                }
            }).then(response => {
                setOrder(response.data.id)
                setEmail(response.data.email)
            })
                .catch(error => console.log(error))
                .finally(() => {
                    setLoading(false);   // <-- Turn off loading after fetch
                });
        } else {
            setLoading(false);
        }
    }

    useEffect(() => {
        getOrderInfo()
    }, []);

    return (<div className='succes'>

        <style>
            {`
.loadingBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top-color: #5a8dee;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`}
        </style>

        {loading ? (
            <div className="loadingBox">
                <div className="spinner"></div>
                <p>{t("Tabs.waiting")}</p>
            </div>
        ) : (order ? (<>
                <div className='modalCont'>
                    <h2>{t("Tabs.thanks")}</h2>

                </div>
                <div className="modalText">{t("Tabs.thanksdetail1")} <span> {order} </span>
                    {t("Tabs.thanksdetail2")} {email} {t("Tabs.thanksdetail3")} </div>
                <Link to={`/${i18n.language}`}>
                    <button className="continuShop">{t("shop.continue")}</button>
                </Link>
            </>) : (<>
                <div className='amerfail'>
                    <div className='modalCont'>
                        <h2 className='errortext'>{t("Tabs.thankserror")}</h2>


                    </div>

                    <Link to={`/${i18n.language}`}>
                        <button className="continuShop">{t("shop.continue")}</button>
                    </Link>
                </div>
            </>)
        )}

    </div>)
}

export {Ameriasuccess}
